import React from 'react';
import { Outlet } from 'react-router-dom';
import { SiteNav } from './SiteNav';
import { SiteFooter } from './SiteFooter';
export function Layout() {
  return <div className="min-h-screen flex flex-col bg-bodybg font-sans text-[#E5E5E5] antialiased" data-id="element-86">
      <SiteNav data-id="element-87" />
      <main className="flex-1" data-id="element-88">
        <Outlet data-id="element-89" />
      </main>
      <SiteFooter data-id="element-90" />
    </div>;
}